import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MaxBrainSharedModule } from 'app/projects/shared/src/lib/shared.module';
import { SelectUsersDialogComponent } from './select-users-dialog.component';

@NgModule({
    imports: [MatIconModule, MatToolbarModule, MatAutocompleteModule, MatFormFieldModule, MatListModule, MatCardModule, MatButtonModule, MatInputModule, MaxBrainSharedModule],
    declarations: [SelectUsersDialogComponent],
    exports: [SelectUsersDialogComponent],
})
export class SelectUsersDialogModule {}
